import actionTypes from '../actions/actionTypes';


export default function cityAutoSuggest(state = {isLoading: false, results: [], hasError: false}, action) {
  switch (action.type) {
  case actionTypes.CITY_AUTOCOMPLETE_REQUEST:
    return {
      isLoading: true,
      results: [],
      hasError: false
    };

  case actionTypes.CITY_AUTOCOMPLETE_SUCCESS:
    return {
      isLoading: false,
      results: action.response.data.results,
      hasError: false
    };

  case actionTypes.CITY_AUTOCOMPLETE_FAILURE:
    return {
      isLoading: false,
      results: [],
      hasError: true
    };
  };

  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/cityAutoSuggestReducer.js